module.exports = __webpack_public_path__ + "img/secret-kitchen_logo.2bd35d18.jpg";